import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import Button from '../../../Button';
import Title from '../../../Title';
import Icon from '../../../Icon';
import Select from 'react-select';
import { getPlanByClientValue } from '../../../../constants/plans';

import { sendVirtualMemberDetails, getVirtualMemberDetails } from '../../../../reducers/authVirtualMember';
const planPeriods = [
  {
    value: 'Monthly',
    label: 'חודשי'
  },
  {
    value: 'Yearly',
    label: 'שנתי'
  },
  {
    value: 'Half year',
    label: 'חצי שנתי'
  }
];
class DealDetails extends Component {
  constructor(props) {
    super(props);
    const plan = getPlanByClientValue(this.props.summary.get('membershipPlan'));
    this.state = {
      plan,
      name: this.props.summary.get('firstName', ''),
      lastName: this.props.summary.get('lastName', ''),
      address: this.props.summary.get('address', ''),
      city: this.props.summary.get('city', ''),
      email: this.props.summary.get('email', ''),
      planPeriod: {
        value: 'Monthly',
        plainLabel: 'חודשי',
        label: `חודשי - ${plan.price['Monthly']} ש״ח`
      },
      privacyPolicy: this.props.summary.get('privacyPolicy', false),
      servicesPolicy: this.props.summary.get('servicesPolicy', false),
      invalidName: null,
      invalidEmail: null,
      invalidLastName: null,
      invalidNationalIdNumber: null
    };
    this.continue = this.continue.bind(this);
    this.captureInputs = this.captureInputs.bind(this);
    this.selectAllText = this.selectAllText.bind(this);
    this.getValidationError = this.getValidationError.bind(this);
  }

  componentDidUpdate() {}

  getValidationError(value, regexFormat, regexEmpty, errorFormat, errorEmpty) {
    if (regexEmpty.test(value)) {
      console.log('empty', errorFormat);
      return errorEmpty;
    } else if (!regexFormat.test(value)) {
      console.log('errorformat', errorFormat);
      return errorFormat;
    } else {
      console.log('no error', this.state.name);
      return null;
    }
  }

  continue(event) {
    event.preventDefault();
    const i18n = this.props.lang.i18n;
    const emailValidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
    const textValidation = /.*/; // /^(([^\u0000-\u007f]+|\w|-|\s)+)$/;
    const emptyValidation = /^$/;
    const invalidName = this.getValidationError(
      this.state.name,
      textValidation,
      emptyValidation,
      i18n('onboarding.formValidation.invalidName'),
      i18n('onboarding.formValidation.invalidEmpty')
    );
    const invalidLastName = this.getValidationError(
      this.state.lastName,
      textValidation,
      emptyValidation,
      i18n('onboarding.formValidation.invalidLastName'),
      i18n('onboarding.formValidation.invalidEmpty')
    );
    const invalidEmail = this.getValidationError(
      this.state.email,
      emailValidation,
      emptyValidation,
      i18n('onboarding.formValidation.invalidEmail'),
      i18n('onboarding.formValidation.invalidEmpty')
    );
    const invalidNationalIdNumber = this.getValidationError(
      this.state.nationalIdNumber,
      emptyValidation,
      emptyValidation,
      i18n('onboarding.formValidation.invalidName'),
      i18n('onboarding.formValidation.invalidEmpty')
    );
    this.setState({
      invalidNationalIdNumber,
      invalidName,
      invalidLastName,
      invalidEmail
    });
    let userData = Map();
    const overrideMemberAddress = `${this.state.address}, ${this.state.city}`;
    userData = userData.set('firstName', this.state.name);
    userData = userData.set('lastName', this.state.lastName);
    userData = userData.set('email', this.state.email);
    userData = userData.set('overrideMemberAddress', overrideMemberAddress);
    userData = userData.set('servicesPolicy', this.state.servicesPolicy);
    userData = userData.set('privacyPolicy', this.state.privacyPolicy);
    userData = userData.set('planPeriod', this.state.planPeriod.value);
    this.props.sendVirtualMemberDetails(userData);
    this.props.updateSummary(userData);
    if (
      this.state.privacyPolicy &&
      textValidation.test(this.state.name) &&
      textValidation.test(this.state.lastName) &&
      emailValidation.test(this.state.email)
    ) {
      this.props.next();
    } else {
      console.log('you need to agree the policy');
    }
  }

  captureInputs(event) {
    const target = event.target;
    let val = event.target.value;
    const name = target.name;
    if (name === 'servicesPolicy' || name === 'privacyPolicy') {
      val = target.checked;
    }
    this.setState({
      [name]: val,
      invalidName: null,
      invalidLastName: null,
      invalidEmail: null
    });
  }

  selectAllText(event) {
    event.target.select();
  }

  render() {
    const { planPeriod, plan } = this.state;
    const i18n = this.props.lang.i18n;
    const errorName = <span>{this.state.invalidName}</span>;
    const errorLastName = <span>{this.state.invalidLastName}</span>;
    const errorNationalIdNumber = <span>{this.state.invalidNationalIdNumber}</span>;
    const errorEmail = <span>{this.state.invalidEmail}</span>;
    const colourStyles = {
      option: styles => ({ ...styles, width: '100%' }),
      singleValue: styles => ({ ...styles, width: '100%' }),
      placeholder: styles => ({ ...styles, width: '100%' })
    };
    return (
      <React.Fragment>
        <div className="user-details text-center">
          <Title text={'הצטרפות לחבילה'} className="form__title" />
          <p className="mb-5">
            {plan.name}, מסלול <strong>{planPeriod.plainLabel || planPeriod.label}</strong> ב {plan.price[planPeriod.value]} ש״ח לחודש
            <strong>{plan.discountedMonth ? `, חודש ראשון ב ${plan.discountedMonth}` : ''}</strong>
          </p>
          <div className="row justify-content-center">
            <div className="col-9 col-sm-5">
              <form className="form">
                <div className="row mb-3">
                  <p>מסלול תשלום</p>
                  <Select
                    className="bankDetails__select w-100"
                    styles={colourStyles}
                    classNamePrefix="select"
                    placeholder={i18n('onboarding.planPeriod')}
                    value={planPeriod}
                    onChange={value => this.setState({ planPeriod: value })}
                    options={planPeriods.map(v => ({ ...v, plainLabel: v.label, label: `${v.label} - ${plan.price[v.value]} ש״ח` }))}
                  />
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <input
                      className={`form__input ${this.state.invalidName !== null ? 'form__input--error' : 'form__input mw-100 mb-3'}`}
                      type="text"
                      name="name"
                      autoComplete="given-name"
                      onChange={this.captureInputs}
                      onClick={this.selectAllText}
                      value={this.state.name}
                      placeholder={i18n('onboarding.userDetails.firstName')}
                    />
                    {errorName && <div className="form__error-small">{errorName}</div>}
                  </div>
                  <div className="col-sm-6">
                    <input
                      className={`form__input ${this.state.invalidLastName !== null ? 'form__input--error' : 'form__input mw-100 mb-3'}`}
                      type="text"
                      name="lastName"
                      autoComplete="family-name"
                      onChange={this.captureInputs}
                      onClick={this.selectAllText}
                      value={this.state.lastName}
                      placeholder={i18n('onboarding.userDetails.lastName')}
                    />
                    {errorLastName && <div className="form__error-small">{errorLastName}</div>}
                  </div>
                </div>
                <input
                  className="form__input mw-100 mb-3"
                  type="text"
                  name="address"
                  onChange={this.captureInputs}
                  onClick={this.selectAllText}
                  value={this.state.address}
                  placeholder={i18n('onboarding.userDetailsVirtualMember.address')}
                />
                {errorNationalIdNumber && <div className="form__error-small">{errorNationalIdNumber}</div>}
                <input
                  className="form__input mw-100 mb-3"
                  type="text"
                  name="city"
                  onChange={this.captureInputs}
                  onClick={this.selectAllText}
                  value={this.state.city}
                  placeholder={i18n('onboarding.userDetailsVirtualMember.city')}
                />
                {errorNationalIdNumber && <div className="form__error-small">{errorNationalIdNumber}</div>}
                <input
                  // className="form__input mw-100 mb-4 mb-sm-5"
                  className={`form__input ${this.state.invalidEmail !== null ? 'form__input--error' : 'form__input mw-100 mb-4 mb-sm-5'}`}
                  type="email"
                  name="email"
                  onChange={this.captureInputs}
                  onClick={this.selectAllText}
                  value={this.state.email}
                  placeholder={i18n('onboarding.userDetails.email')}
                />
                {errorEmail && <div className="form__error-small">{errorEmail}</div>}
                <div className="text-initial mb-4 mb-sm-5 d-flex">
                  <input
                    className="form__checkbox no-shrink"
                    id="privacyPolicy"
                    type="checkbox"
                    name="privacyPolicy"
                    checked={this.state.privacyPolicy}
                    onChange={this.captureInputs}
                    onClick={this.selectAllText}
                  />
                  <label htmlFor="privacyPolicy" className="form__checkbox--fake">
                    <Icon name="checkmark" />
                  </label>
                  <label className="form__label mb-0" htmlFor="privacyPolicy">
                    {i18n('onboarding.userDetails.privacyPolicyLinkText1')}{' '}
                    <a
                      className=""
                      href="https://s3-eu-west-1.amazonaws.com/venn-app/Registration+flow+privacy+policy.pdf"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {i18n('onboarding.userDetails.privacyPolicyLinkText2')}
                    </a>{' '}
                    {i18n('onboarding.userDetails.privacyPolicyLinkText3')}
                    <a
                      className=""
                      href="https://app-storage.venn.city/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F+%D7%A9%D7%99%D7%A8%D7%95%D7%AA%D7%99%D7%9D.pdf"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {i18n('onboarding.userDetails.privacyPolicyLinkText4')}
                    </a>
                  </label>
                </div>
                <div className="text-initial mb-4 mb-sm-5">
                  <div className="d-flex">
                    <input
                      className="form__checkbox"
                      id="servicesPolicy"
                      type="checkbox"
                      name="servicesPolicy"
                      checked={this.state.servicesPolicy}
                      onChange={this.captureInputs}
                    />
                    <label htmlFor="servicesPolicy" className="form__checkbox--fake no-shrink">
                      <Icon name="checkmark" />
                    </label>
                    <label className="form__label mb-0" htmlFor="servicesPolicy">
                      {i18n('onboarding.userDetails.servicesTerms1')}{' '}
                      <a className="" href="https://app-storage.venn.city/servicesContract.pdf" target="_blank" rel="noreferrer noopener">
                        {i18n('onboarding.userDetails.servicesTerms2')}
                      </a>
                    </label>
                  </div>
                </div>
                <Button
                  text={i18n('onboarding.userDetails.buttonText')}
                  disabled={!this.state.privacyPolicy || !this.state.servicesPolicy}
                  onClick={this.continue}
                />
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  virtualMemberDetails: getVirtualMemberDetails(state),
  lang: state.lang
});

const actionMakers = {
  sendVirtualMemberDetails
};

export default connect(
  mapStateToProps,
  actionMakers
)(DealDetails);



// WEBPACK FOOTER //
// ./src/components/Views/OnboardingVirtualMembers/Steps/UserDetailsVirtualMember.js